import type { MenuPlantilla } from '../types/menuDigital';

// Plantillas y paletas curadas del menú digital. Fuente de verdad de diseño:
// docs/menu-digital.md (tablas de hex) y el mockup aprobado en
// docs/mockups/menu-digital-plantillas.html. Los colores se eligen SIEMPRE por
// paleta completa, nunca sueltos — así ningún menú queda ilegible. La primera
// paleta de cada plantilla es la default (colores vacíos en settings).

export interface PaletaCurada {
  nombre: string;
  colores: [string, string, string, string];
}

export interface PlantillaInfo {
  nombre: string;
  descripcion: string;
  /** Rol de cada slot de color, en el orden del arreglo `colores`. */
  slots: [string, string, string, string];
  paletas: PaletaCurada[];
}

export const PLANTILLAS: Record<MenuPlantilla, PlantillaInfo> = {
  carta: {
    nombre: 'Carta',
    descripcion: 'La carta de siempre: serif, marco doble y puntitos hasta el precio',
    slots: ['Papel', 'Tinta', 'Texto', 'Secundario'],
    paletas: [
      { nombre: 'Vino', colores: ['#f8f3e7', '#8a2f2b', '#33302a', '#7d766a'] },
      { nombre: 'Botella', colores: ['#f4f6ef', '#2e5339', '#2b302a', '#6f7a6a'] },
      { nombre: 'Marino', colores: ['#f5f4ee', '#274168', '#2a2d33', '#6d7480'] },
      { nombre: 'Sepia', colores: ['#f7f1e3', '#6b5433', '#3a332a', '#837462'] },
    ],
  },
  moderna: {
    nombre: 'Moderna',
    descripcion: 'Editorial: cabecera de tinta, categorías grandes y un acento',
    slots: ['Fondo', 'Tinta', 'Acento', 'Gris'],
    paletas: [
      { nombre: 'Rosa mexicano', colores: ['#fbfaf7', '#171512', '#e5347f', '#8b857b'] },
      { nombre: 'Cobalto', colores: ['#f9fafb', '#14161c', '#2545d3', '#7d818c'] },
      { nombre: 'Naranja', colores: ['#fbf9f6', '#1a1713', '#e05a1e', '#8a837a'] },
      { nombre: 'Bosque', colores: ['#f8fbf8', '#121a14', '#0f8a5f', '#7a857e'] },
    ],
  },
  pizarra: {
    nombre: 'Pizarra',
    descripcion: 'Pizarrón oscuro con acentos de gis; donde más luce el menú del día',
    slots: ['Pizarrón', 'Gis', 'Acento', 'Destacado'],
    paletas: [
      { nombre: 'Clásica', colores: ['#222a25', '#efece0', '#e8c46b', '#e2938f'] },
      { nombre: 'Nocturna', colores: ['#1d2430', '#e8ecf2', '#9fc6e8', '#e8c46b'] },
      { nombre: 'Cantina', colores: ['#2b2022', '#f0e9e4', '#e8a46b', '#9fd8c0'] },
      { nombre: 'Menta', colores: ['#20302c', '#eaf2ec', '#a8e6c8', '#f0d58c'] },
    ],
  },
};

/** Paleta efectiva: la elegida si es válida, si no la default de la plantilla. */
export function resolveColores(plantilla: MenuPlantilla, colores: string[]): [string, string, string, string] {
  if (colores.length === 4) {
    return colores as [string, string, string, string];
  }
  return PLANTILLAS[plantilla].paletas[0].colores;
}
